import React, { forwardRef, useEffect, useState } from "react";
import styled from "styled-components";
import { userApi } from "../../api/user-api";
import { useAppSelector } from "../../app/hooks";
import { scheduleState } from "../../app/reducers/schedule-slice";
import { UserPageDto } from "../../types/user/user-dto";
import { useDebouncedCallback } from "../../utils/custom-hook/use-debounced-callback";
import useDidMountEffect from "../../utils/custom-hook/use-did-mount-effect";
import { LabelAutocomplete } from "./LabelAutocomplete";

interface Props {
  // deliveryGroupName?: string;
  userId?: string;
  updateUserId: (id?: string) => void;
  ref: React.MutableRefObject<HTMLInputElement>;
}

export const SearchUser = forwardRef<HTMLInputElement, Props>(
  ({ updateUserId, userId }, ref) => {
    const { updateSchedule, dateToWork } = useAppSelector(scheduleState);
    const [searchUser, setSearchUser] = useState<string>("");
    const [searchUserList, setSearchUserList] = useState<UserPageDto>();
    const [candidateMap, setCandidateMap] = useState<{ [key: string]: string }>(
      {}
    );

    const handleChangeSearchUser = (
      event: React.ChangeEvent<HTMLInputElement>
    ) => {
      setSearchUser(event.target.value);
    };

    const getUsersByName = useDebouncedCallback(async () => {
      try {
        const response = await userApi.search({ name: searchUser, page: 0 });
        setSearchUserList(response.data);
      } catch (error) {
        console.error(error);
      }
    });

    const clearSearchUserList = () => {
      setSearchUserList({
        contents: [],
        first: true,
        last: true,
        page: 0,
        totalPages: 0,
        totalElements: 0,
      });
    };

    const resetTextField = () => {
      setSearchUser("");
      updateUserId(undefined);
    };

    const onClickSelectItem = (key: string) => {
      setSearchUser(candidateMap[key]);
      updateUserId(key);
    };

    const initUpdateUser = () => {
      if (!updateSchedule?.worker) {
        return;
      }

      setSearchUser(updateSchedule.worker.name);
      updateUserId(updateSchedule.worker.id);
    };

    useEffect(() => {
      const newCandidateMap: { [key: string]: string } = {};
      searchUserList?.contents.forEach((user) => {
        newCandidateMap[user.id] = user.name;
      });
      setCandidateMap(newCandidateMap);
    }, [searchUserList]);

    useDidMountEffect(() => {
      if (searchUser !== "") {
        getUsersByName();
      } else {
        clearSearchUserList();
      }
    }, [searchUser]);

    useEffect(() => {
      initUpdateUser();
    }, [updateSchedule]);

    useDidMountEffect(() => {
      if (!userId) {
        setSearchUser("");
      }
    }, [userId]);

    return (
      <SearchUserContainer>
        <LabelAutocomplete
          width="240px"
          placeholder="배정 프로님 검색"
          value={searchUser}
          candidateMap={candidateMap}
          onClickSelectItem={(key: string) => onClickSelectItem(key)}
          onChangeTextField={handleChangeSearchUser}
          resetTextField={resetTextField}
          isActive={Boolean(userId)}
          disabled={Boolean(userId)}
          label="배송원 : "
        />
      </SearchUserContainer>
    );
  }
);

const SearchUserContainer = styled.div`
  margin-left: 8px;
  z-index: 9999999;
`;
